import { render, staticRenderFns } from "./ConfigEditor.vue?vue&type=template&id=54e4b2d2&scoped=true&"
import script from "./ConfigEditor.vue?vue&type=script&lang=js&"
export * from "./ConfigEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e4b2d2",
  null
  
)

export default component.exports